var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMdiCloudUploadOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 91,
    height: 66,
    viewBox: "0 0 91 66",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.0416 65.6667C16.8349 65.6667 11.5402 63.5298 7.15742 59.2559C2.77464 54.9548 0.583252 49.7145 0.583252 43.535C0.583252 38.2267 2.17575 33.49 5.36075 29.325C8.57298 25.16 12.7652 22.5059 17.9374 21.3625C19.6524 15.1014 23.0552 10.0381 28.1458 6.17254C33.2635 2.27976 39.0483 0.333374 45.4999 0.333374C53.476 0.333374 60.2271 3.11004 65.7533 8.66337C71.3066 14.1895 74.0833 20.9406 74.0833 28.9167C78.7927 29.4611 82.6855 31.5028 85.7616 35.0417C88.8649 38.5261 90.4166 42.6095 90.4166 47.2917C90.4166 52.4095 88.6335 56.7514 85.0674 60.3175C81.5013 63.8836 77.1594 65.6667 72.0416 65.6667H49.5833C47.351 65.6667 45.4319 64.8636 43.8258 63.2575C42.2196 61.6786 41.4166 59.7595 41.4166 57.5V36.4709L34.8833 42.8L29.1666 37.0834L45.4999 20.75L61.8333 37.0834L56.1166 42.8L49.5833 36.4709V57.5H72.0416C74.8999 57.5 77.3091 56.5064 79.2691 54.5192C81.2563 52.5592 82.2499 50.15 82.2499 47.2917C82.2499 44.4334 81.2563 42.0242 79.2691 40.0642C77.3091 38.077 74.8999 37.0834 72.0416 37.0834H65.9166V28.9167C65.9166 23.2817 63.9294 18.4634 59.9549 14.4617C55.9805 10.4873 51.1621 8.50004 45.4999 8.50004C39.8649 8.50004 35.0466 10.4873 31.0449 14.4617C27.0705 18.4634 25.0833 23.2817 25.0833 28.9167H23.0416C19.0944 28.9167 15.7324 30.3186 12.9558 33.1225C10.1519 35.8992 8.74992 39.2612 8.74992 43.2084C8.74992 47.1556 10.1519 50.5584 12.9558 53.4167C15.7324 56.1389 19.0944 57.5 23.0416 57.5H33.2499V65.6667",
    fill: "url(#paint0_linear_158_356)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_158_356",
    x1: 0.583282,
    y1: 65.6667,
    x2: 50.0645,
    y2: 97.4295,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00C2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9746FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMdiCloudUploadOutline);
export default __webpack_public_path__ + "static/media/mdi_cloud-upload-outline.61aeb7a75cc65892bdfaecfc7cc97fb4.svg";
export { ForwardRef as ReactComponent };